/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('region.skireport')
 */
import { RegionLayout } from 'page-components/region/_layout';
import Component, { getRegionSkiReportPageServerSideProps } from 'page-components/region/skireport';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchRegionSlugs } from 'util/fetchStaticPageRegion';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: RegionLayout });

export const getServerSideProps = propsWithI18NSSR(getRegionSkiReportPageServerSideProps);
/* export const getStaticPaths = async () => packPaths((await fetchRegionSlugs('region.skireport')).map((reg) => ({
  region: reg.slug,
}))); */
